import React from "react";
import { Map, X } from "lucide-react";
import { photoUrl } from "../../lib/api";
import { stopPointer } from "./treeConstants";

export function TreeMinimap({ vis, disp, CW, CH, colorBy, colorFor, t, contentRef, viewportRef, mmRef, mmDragRef, navMinimap, hoverName, onHover, onClose }) {
  const cw = contentRef.current?.w || 1, ch = contentRef.current?.h || 1;
  const ms = Math.min(180 / cw, 130 / ch);
  const vp = viewportRef.current; const vw = vp ? vp.clientWidth : 0, vh = vp ? vp.clientHeight : 0;
  const ts = t?.scale || 1, tx = t?.x ?? 0, ty = t?.y ?? 0;
  return (
    <div className="absolute bottom-5 left-5 z-30 rounded-xl border border-[#D8E0E8] bg-white/90 p-2 shadow-md backdrop-blur" data-testid="minimap" onPointerDown={stopPointer}>
      <div className="mb-1.5 flex items-center justify-between gap-3 px-0.5">
        <span className="flex items-center gap-1 truncate text-[10px] font-bold uppercase tracking-wider text-[#64748B]" data-testid="minimap-label"><Map size={11} className="shrink-0" /> <span className="truncate">{hoverName || "Overview"}</span></span>
        <button onClick={onClose} data-testid="minimap-close-button" title="Close overview" className="rounded-full p-0.5 text-[#94A3B8] hover:bg-[#E8EEF3] hover:text-[#082D4A]"><X size={13} /></button>
      </div>
      <div ref={mmRef} className="relative cursor-pointer overflow-hidden rounded-md bg-[#F4F6F8]" style={{ width: cw * ms, height: ch * ms }}
        onPointerDown={(e) => { e.stopPropagation(); mmDragRef.current = true; navMinimap(e, true); }}
        onPointerMove={(e) => { if (mmDragRef.current) navMinimap(e, false); }}
        onPointerUp={() => { mmDragRef.current = false; }}
        onPointerLeave={() => { mmDragRef.current = false; onHover(null); }}>
        {vis.map((m) => {
          const p = disp(m.id); if (!p) return null;
          const w = Math.max(3, CW * ms), h = Math.max(3, CH * ms);
          const ph = photoUrl(m.photo_path);
          return (
            <span key={m.id} title={m.full_name} onPointerEnter={() => onHover(m.full_name)} data-testid={`minimap-cell-${m.id}`} className="absolute overflow-hidden rounded-[2px] ring-1 ring-black/5 hover:ring-2 hover:ring-[#082D4A]" style={{ left: p.x * ms, top: p.y * ms, width: w, height: h, backgroundColor: colorBy ? colorFor(m.id) : "#94A3B8" }}>
              {ph && w >= 6 && <img src={ph} alt="" loading="lazy" draggable={false} className="h-full w-full object-cover" />}
            </span>
          );
        })}
        <div data-testid="minimap-viewport" className="absolute rounded-[2px] border-2 border-[#D4A017] bg-[#D4A017]/10" style={{ left: (-tx / ts) * ms, top: (-ty / ts) * ms, width: (vw / ts) * ms, height: (vh / ts) * ms }} />
      </div>
    </div>
  );
}
